"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Must stay in lock-step with the server sanitiser and the configurator's
// `normaliseSuggestedQuestion`. Defense-in-depth: legacy data / manual config
// edits / future migration bugs all get caught at the rendering boundary
// instead of leaking control characters into `title=`, garbled URLs into the
// search query, or `<script>` lookalikes into the chip label.
var RENDER_MAX_QUESTIONS = 3;
var RENDER_MAX_LENGTH = 100; // eslint-disable-next-line no-control-regex

var RENDER_CONTROL_CHARS = /[ --]/g; // Substring needles in place of `/<[^>]*>/` and `/https?:\/\//i`. Plain
// string scans rather than regex so SonarQube doesn't flag this layer as a
// ReDoS surface even though the patterns are intrinsically linear — the
// data here is read straight out of the DB and could be of any shape.

var RENDER_URL_NEEDLES = ['http://', 'https://'];

function sanitiseForRender(input) {
  if (!Array.isArray(input)) return [];
  var cleaned = [];

  var _iterator = _createForOfIteratorHelper(input),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      if (typeof entry !== 'string') continue; // Trim → cap *before* the rejection scan. Render input is whatever sits
      // in the DB (malformed legacy data, in-flight migration leftovers, etc.)
      // so any one value could be of arbitrary size. Bounding to ≤100 chars
      // first caps per-entry CPU regardless of payload.

      var candidate = entry.replace(RENDER_CONTROL_CHARS, '').trim().slice(0, RENDER_MAX_LENGTH);
      if (!candidate || containsDisqualifiedContent(candidate)) continue;
      cleaned.push(candidate);
      if (cleaned.length >= RENDER_MAX_QUESTIONS) break;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return cleaned;
}
/**
 * Mirrors the server sanitiser's `isDisqualified`: reject HTML-like markup
 * (`<…>`) and http(s) URLs via linear substring search. No regex.
 */


function containsDisqualifiedContent(value) {
  var lt = value.indexOf('<');
  var looksLikeMarkup = lt !== -1 && value.includes('>', lt + 1);
  var lower = value.toLowerCase();
  var looksLikeUrl = RENDER_URL_NEEDLES.some(function (needle) {
    return lower.includes(needle);
  });
  return looksLikeMarkup || looksLikeUrl;
} // Inline Material-style "trending up" glyph — line chart going up-right with an
// arrow head. Inlined (vs. a shared icon file) because it's only used here.


var TrendingUpIcon = function TrendingUpIcon() {
  return (0, _preact.h)("svg", {
    className: "live-search-suggested-questions__try-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, (0, _preact.h)("path", {
    d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
  }));
};

var SuggestedQuestionsRow = function SuggestedQuestionsRow(_ref) {
  var questions = _ref.questions,
      _ref$centered = _ref.centered,
      centered = _ref$centered === void 0 ? true : _ref$centered;

  // Community-level kill-switch. When the `liveSearchBannerSuggestedQuestions`
  // module flag is off, the row is fully hidden regardless of what's saved in
  // the widget config — matches the configurator behaviour where the editor
  // section also disappears, so flipping the flag off removes the feature
  // end-to-end without needing to clear the saved questions.
  if (!_common.common.isModuleActive('liveSearchBannerSuggestedQuestions')) {
    return null;
  }

  var safeQuestions = sanitiseForRender(questions);

  if (safeQuestions.length === 0) {
    return null;
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('live-search-suggested-questions', {
      'live-search-suggested-questions--left': !centered
    }),
    role: "list"
  }, (0, _preact.h)("span", {
    className: "live-search-suggested-questions__try",
    "aria-hidden": "true"
  }, (0, _preact.h)(TrendingUpIcon, null), (0, _preact.h)("span", {
    className: "live-search-suggested-questions__try-label"
  }, "Try:")), safeQuestions.map(function (question, index) {
    return (// Composite key so identical question strings (allowed by the backend)
      // don't trigger React's duplicate-key warning or lose a node on re-render.
      (0, _preact.h)("a", {
        key: "".concat(index, "-").concat(question),
        href: (0, _absoluteUrlRuntime.resolveUrl)("/search?q=".concat(encodeURIComponent(question))),
        className: "live-search-suggested-questions__item",
        role: "listitem",
        title: question
      }, (0, _preact.h)("span", {
        className: "live-search-suggested-questions__text"
      }, question))
    );
  }));
};

var _default = SuggestedQuestionsRow;
exports.default = _default;